import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  fragment FragmentMosaicUiOpenAssistantActionRendering on MosaicUiOpenAssistantActionRendering {
    agentId
    records {
      modelId
      recordId
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicUiOpenAssistantActionRenderingFragment,
  ents.core.mosaic.Action.Rendering<ents.core.mosaic.Action.Operation.UiOpenAssistant>
>({
  operation: () => ents.core.mosaic.Action.Operation.UiOpenAssistant,
  payload: {
    usingFullInput: graphql.transformers.OUT.validate(
      graphql.transformers.OUT.object<
        graphql.schema.FragmentMosaicUiOpenAssistantActionRenderingFragment,
        ents.core.mosaic.Action.Payload<ents.core.mosaic.Action.Operation.UiOpenAssistant>
      >({
        agentId: graphql.transformers.OUT.validate(
          common.gql.enums.agentId.TRANSFORMER,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        records: graphql.transformers.OUT.validate(
          graphql.transformers.OUT.list<
            { modelId: string; recordId: string } | null,
            ents.core.agent.KnowledgeBase.Retrieval.Record | undefined
          >(
            graphql.transformers.OUT.object<
              { modelId: string; recordId: string },
              ents.core.agent.KnowledgeBase.Retrieval.Record
            >({
              modelId: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                ents.core.dms.models.ForRecord.Id.assertIsId,
              ),
              recordId: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                ents.core.dms.data.Record.Id.assertIsId,
              ),
            }),
            { onNullish: 'remove' },
          ),
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
      }),
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  },
})
